import { Instance, SnapshotIn, SnapshotOut, types } from "mobx-state-tree"

export const TripCollaboratorModel = types.model("TripCollaborator").props({
  userId: types.string,
  firstName: types.string,
  lastName: types.string,
  avatar: types.maybeNull(types.string),
  twilioParticipantSid: types.optional(types.string, ""),
  inviteLink: types.optional(types.string, ""),
  type: types.optional(types.union(types.literal("user"), types.literal("agent")), "user"),
})

export type TripCollaborator = Instance<typeof TripCollaboratorModel>
export type TripCollaboratorSnapshotOut = SnapshotOut<typeof TripCollaboratorModel>
export type TripCollaboratorSnapshotIn = SnapshotIn<typeof TripCollaboratorModel>
